// extracted by mini-css-extract-plugin
export default {"form":"MessageUsForm_form__q9MpY","title":"MessageUsForm_title__fpxhw","MessageI":"MessageUsForm_MessageI__Ur-QL","btn":"MessageUsForm_btn__eCX2F","icon":"MessageUsForm_icon__47U1h"};